import styled from 'styled-components';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_2_XL, } from '@oneaudi/unified-web-alpha-common';
export const StyledTechnicalSection = styled.div `
  margin-top: 8px;
  display: flex;
  flex-direction: column;

  > div {
    margin-top: ${SYS_SPACE_RELATIVE_2_XL};
    &:first-child {
      margin-top: 0;
    }
  }

  td {
    padding: 0 !important;
  }

  .value-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    word-break: break-word;
    flex: 1;
  }

  .technical-key {
    margin-top: ${SYS_SPACE_FIXED_300};
  }

  .technical-value {
    margin-top: ${SYS_SPACE_FIXED_100};
    margin-bottom: ${SYS_SPACE_FIXED_300};
  }
`;
